import { render, staticRenderFns } from "./MExpandingInput.vue?vue&type=template&id=82fa3152"
import script from "./MExpandingInput.vue?vue&type=script&lang=js"
export * from "./MExpandingInput.vue?vue&type=script&lang=js"
import style0 from "./MExpandingInput.vue?vue&type=style&index=0&id=82fa3152&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports